import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
export function AcToggle({ value, options, onChange, disabled = false, name, ariaLabel, className, }) {
    const autoName = useId();
    const groupName = name ?? autoName;
    const wrapperClass = className ? `ac-toggle ${className}` : 'ac-toggle';
    return (_jsx("div", { className: wrapperClass, role: "radiogroup", "aria-label": ariaLabel, "data-disabled": disabled || undefined, children: options.map((opt) => {
            const isActive = opt.value === value;
            const handleChange = (e) => {
                if (e.target.checked)
                    onChange(opt.value);
            };
            return (_jsxs("label", { className: "ac-toggle__option", "data-active": isActive || undefined, "data-testid": opt.dataTestId, children: [_jsx("input", { className: "ac-toggle__input", type: "radio", name: groupName, value: opt.value, checked: isActive, onChange: handleChange, disabled: disabled }), _jsx("span", { className: "ac-toggle__label", children: opt.label })] }, opt.value));
        }) }));
}
//# sourceMappingURL=AcToggle.js.map